<form [formGroup]="timeFrame">
  <mat-form-field [floatLabel]="'never'" appearance="outline">
    <mat-label>From date</mat-label>
    <input
      matInput
      [matDatepicker]="from"
      [min]="minDate"
      formControlName="dateFrom"
      (click)="from.open()"
      autocomplete="off"
      [disabled]="isProcessing"
    />
    <mat-datepicker-toggle
      matSuffix
      [for]="from"
      [disabled]="isProcessing"
    ></mat-datepicker-toggle>
    <mat-datepicker #from [disabled]="isProcessing"></mat-datepicker>
  </mat-form-field>
  <mat-form-field [floatLabel]="'never'" appearance="outline" class="ml-3">
    <mat-label>To date</mat-label>
    <input
      matInput
      [matDatepicker]="to"
      formControlName="dateTo"
      (click)="to.open()"
      autocomplete="off"
      [disabled]="isProcessing"
      [min]="timeFrame.get('dateFrom').value"
    />
    <mat-datepicker-toggle
      matSuffix
      [for]="to"
      [disabled]="isProcessing"
    ></mat-datepicker-toggle>
    <mat-datepicker #to [disabled]="isProcessing"></mat-datepicker>
  </mat-form-field>
</form>

<div>
  <app-processing-boundary
    [isProcessing]="isProcessing"
    [showEmptyResultMsg]="!dataSource?.length"
    [emptyResultMsg]="'No results available'"
  >
    <table mat-table [dataSource]="dataSource" class="w-full mb-4">
      <ng-container matColumnDef="websiteName">
        <th mat-header-cell *matHeaderCellDef>Website</th>
        <td mat-cell *matCellDef="let element">{{ element.websiteName }}</td>
      </ng-container>

      <ng-container matColumnDef="headlinesCount">
        <th mat-header-cell *matHeaderCellDef>No. headlines</th>
        <td mat-cell *matCellDef="let element">{{ element.headlinesCount }}</td>
      </ng-container>

      <ng-container matColumnDef="headlinesWithTopicsCount">
        <th mat-header-cell *matHeaderCellDef>No. headlines with topics</th>
        <td mat-cell *matCellDef="let element">
          {{ element.headlinesWithTopicsCount }}
        </td>
      </ng-container>

      <ng-container matColumnDef="headlinesWithoutTopicsCount">
        <th mat-header-cell *matHeaderCellDef>No. headlines without topics</th>
        <td mat-cell *matCellDef="let element">
          {{ element.headlinesWithoutTopicsCount }}
        </td>
      </ng-container>

      <ng-container matColumnDef="percentageTagged">
        <th mat-header-cell *matHeaderCellDef>% Tagged</th>
        <td mat-cell *matCellDef="let element">
          {{ element.percentageTagged | number: "1.0-0" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="percentageTaggedPreviousDateRange">
        <th mat-header-cell *matHeaderCellDef>% Tagged previous week</th>
        <td mat-cell *matCellDef="let element">
          {{ element.percentageTaggedPreviousDateRange | number: "1.0-0" }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </app-processing-boundary>
</div>
